// El navegador dispara `beforeinstallprompt` muy pronto, normalmente antes de
// que React haya montado nada. Si solo lo escuchara un componente, el evento ya
// habría pasado y el botón de instalar nunca aparecería. Por eso se captura
// aquí, en un módulo que index.js importa antes de renderizar, y se guarda para
// quien lo pida después.

let diferido = null;
const suscriptores = new Set();

const avisar = () => suscriptores.forEach((fn) => fn(diferido));

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    // Evita la mini barra automática de Chrome; el prompt lo lanzamos nosotros
    // desde el botón, que da mejor contexto al usuario.
    event.preventDefault();
    diferido = event;
    avisar();
  });

  window.addEventListener("appinstalled", () => {
    diferido = null;
    avisar();
  });
}

export const getInstallPrompt = () => diferido;

// El evento solo puede consumirse una vez: tras usarlo hay que soltarlo.
export const clearInstallPrompt = () => {
  diferido = null;
  avisar();
};

export const subscribeInstallPrompt = (fn) => {
  suscriptores.add(fn);
  return () => suscriptores.delete(fn);
};
